import React from 'react';
import { t } from '../../helpers/translate.js';
import { Link } from 'react-router';
import LoadingComponent from './LoadingComponent';
import ModalComponent from './ModalComponent';
import { request } from '../../helpers/request';
const config = require('config');

class EligibilityQuestionnaireComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalTitle: t('Eligibility Questionnaire'),
      modalBody: '',
      showModal: false,
      policyWordingPdfUrl: null,
      loading: false,
    };
  }

  handleModalClose() {
    this.setState({ showModal: false });
  }

  fetchPolicyWordingPdf() {
    const { source, applicationId } = this.props;
    this.setState({ loading: true });

    request(
      `${config.default.api}/application/${source}/getPolicyWordingUrl/${applicationId}`,
      'GET',
      null,
      (responseData, status) => {
        this.setState({ loading: false });
        if (status === 200 && responseData.policy_wording) {
          this.setState({
            policyWordingPdfUrl: responseData.policy_wording,
            modalBody: (
              <iframe
                width="100%"
                height="800"
                src={`${responseData.policy_wording}`}
                type="application/pdf"
                frameborder="0"
              />
            ),
            showModal: true,
          });
        } else {
          this.setState({
            modalTitle: t('Error'),
            modalBody: responseData.messages[0] || t('Unable to retrieve policy wording URL'),
            showModal: true,
          });
        }
      }
    );
  }

  render() {
    const { loading, modalTitle, modalBody, showModal } = this.state;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="btn-group pull-left">
            <button
              className="btn button-secondary pull-right listing-header-link"
              onClick={this.fetchPolicyWordingPdf.bind(this)}
            >
              {t('View Policy Wording')}
            </button>
          </div>
        </div>

        <ModalComponent
          size="large"
          title={modalTitle}
          body={modalBody}
          onClose={this.handleModalClose.bind(this)}
          show={showModal}
        />

        <LoadingComponent show={loading} text={t('Loading')} />
      </div>
    );
  }
}

EligibilityQuestionnaireComponent.displayName = 'EligibilityQuestionnaireComponent';
export default EligibilityQuestionnaireComponent;



// WEBPACK FOOTER //
// ./src/components/common/EligibilityQuestionnaireComponent.js